/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IRoomCountFilter {
  /** UI значение для фильтра (Н-р: Студия) **/
  name: string;
  /** Возможные значения фильтра **/
  value: EValue;
}

export enum EValue {
  /** Студия **/
  'Studio' = 'studio',
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Двухкомнатная квартира **/
  'TwoRoom' = 'twoRoom',
  /** Трехкомнатная квартира **/
  'ThreeRoom' = 'threeRoom',
  /** Четырехкомнатная квартира **/
  'FourRoom' = 'fourRoom',
}
